/* Museo chat — widget untuk snippets/museo-chat.liquid. Backend: chat-worker/ (Cloudflare). */
(() => {
  const root = document.getElementById('MuseoChat');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  const STORE_KEY = 'museo-chat:v1';
  const SESSION_KEY = 'museo-chat:session';
  const base = root.dataset.endpoint.replace(/\/$/, '');
  const launcher = root.querySelector('.mchat__launcher');
  const panel = root.querySelector('.mchat__panel');
  const log = root.querySelector('.mchat__log');
  const form = root.querySelector('.mchat__form');
  const input = root.querySelector('.mchat__input');
  const send = root.querySelector('.mchat__send');
  const chipTemplate = root.querySelector('[data-mchat-chips]');
  const verify = root.querySelector('.mchat__verify');

  // { messages: [{ role, content, products? }], open }
  let state = load();
  let busy = false;

  function load() {
    try {
      const s = JSON.parse(sessionStorage.getItem(STORE_KEY));
      if (s && Array.isArray(s.messages)) return s;
    } catch (e) {}
    return { messages: [], open: false };
  }
  function save() {
    root.classList.toggle('has-msgs', state.messages.length > 0);
    try {
      sessionStorage.setItem(STORE_KEY, JSON.stringify(state));
    } catch (e) {}
  }

  // ---------- Sesi: Turnstile (anti-bot) → token sesi dari Worker ----------
  // Turnstile baru dimuat saat chat pertama kali dibuka. Mode interaction-only: biasanya tidak terlihat,
  // checkbox hanya muncul kalau Cloudflare ragu pengunjungnya manusia.

  let turnstileScript = null;
  let widgetId = null;
  let pendingSession = null;

  function loadTurnstile() {
    if (window.turnstile) return Promise.resolve();
    if (!turnstileScript) {
      turnstileScript = new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
        s.async = true;
        s.onload = resolve;
        s.onerror = () => {
          turnstileScript = null;
          reject(new Error('turnstile_load'));
        };
        document.head.appendChild(s);
      });
    }
    return turnstileScript;
  }

  function turnstileToken() {
    return loadTurnstile().then(
      () =>
        new Promise((resolve, reject) => {
          if (widgetId !== null) window.turnstile.remove(widgetId);
          widgetId = window.turnstile.render(verify, {
            sitekey: root.dataset.sitekey,
            appearance: 'interaction-only',
            size: 'flexible',
            callback: resolve,
            'error-callback': () => reject(new Error('turnstile_error')),
          });
        })
    );
  }

  function getSession(force) {
    if (!force) {
      try {
        const s = JSON.parse(sessionStorage.getItem(SESSION_KEY));
        if (s && s.token && s.expires * 1000 > Date.now() + 60000) return Promise.resolve(s.token);
      } catch (e) {}
    }
    if (!pendingSession) {
      pendingSession = turnstileToken()
        .then((turnstile) =>
          fetch(base + '/session', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ turnstile }),
          })
        )
        .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
        .then(({ ok, data }) => {
          if (!ok || !data.token) throw new Error('session_failed');
          try {
            sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
          } catch (e) {}
          return data.token;
        })
        .finally(() => {
          pendingSession = null;
        });
    }
    return pendingSession;
  }

  async function postChat(payload, force) {
    const token = await getSession(force);
    return fetch(base + '/chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + token },
      body: JSON.stringify(payload),
    });
  }

  // ---------- Render ----------

  function escapeHtml(s) {
    return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  }

  function safeHref(url) {
    try {
      const u = new URL(url, location.origin);
      if (!/^(https?:|mailto:|tel:)$/.test(u.protocol)) return null;
      // Link produk/halaman toko diarahkan ke domain yang sedang dibuka (supaya tetap di preview/dev).
      if (/^https?:$/.test(u.protocol) && /(^|\.)museoco\.com$|myshopify\.com$/.test(u.hostname) && /^\/(products|pages|policies|collections|account)/.test(u.pathname)) {
        return u.pathname + u.search + u.hash;
      }
      return u.href;
    } catch (e) {
      return null;
    }
  }

  // Markdown minimal: paragraf, list, **bold**, *italic*, [text](url), URL polos.
  function inline(text) {
    let out = escapeHtml(text);
    out = out.replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, (_, label, url) => {
      const href = safeHref(url.replace(/&amp;/g, '&'));
      if (!href) return label;
      const ext = /^https?:/.test(href) && !href.startsWith(location.origin);
      return `<a href="${escapeHtml(href)}"${ext ? ' target="_blank" rel="noopener"' : ''}>${label}</a>`;
    });
    out = out.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
    out = out.replace(/(^|[\s(])\*([^*\n]+)\*(?=[\s).,!?]|$)/g, '$1<em>$2</em>');
    return out;
  }

  function markdown(text) {
    const blocks = [];
    let listItems = null;
    for (const raw of text.split('\n')) {
      const line = raw.trim();
      const item = line.match(/^(?:[-*•]|\d+[.)])\s+(.*)$/);
      if (item) {
        (listItems = listItems || []).push(`<li>${inline(item[1])}</li>`);
        continue;
      }
      if (listItems) {
        blocks.push(`<ul>${listItems.join('')}</ul>`);
        listItems = null;
      }
      if (line) blocks.push(`<p>${inline(line.replace(/^#+\s*/, ''))}</p>`);
    }
    if (listItems) blocks.push(`<ul>${listItems.join('')}</ul>`);
    return blocks.join('');
  }

  // ---------- Motion ----------
  // Panel membesar dari launcher (desktop) atau naik dari bawah sebagai layar penuh (mobile). Sisanya kontinuitas:
  // pesan terbang dari input/chip ke bubble-nya, titik-titik mengembang jadi jawaban, kartu masuk berurutan.
  // Semua lewat Web Animations API (bisa dibalik di tengah jalan); reduce-motion → crossfade saja.

  const EASE_OUT = 'cubic-bezier(0.16, 1, 0.3, 1)'; // kedatangan
  const EASE_SHEET = 'cubic-bezier(0.32, 0.72, 0, 1)'; // panel / sheet (kurva sheet iOS)
  const EASE_EXIT = 'cubic-bezier(0.4, 0, 0.7, 0.2)'; // keluar: cepat, tanpa ekor
  const canAnimate = typeof Element.prototype.animate === 'function';
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isSheet = () => matchMedia('(max-width: 599px)').matches; // mobile: panel layar penuh

  function arrive(el, delay = 0) {
    if (!canAnimate || !el) return;
    if (reduced()) {
      el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180, delay, fill: 'backwards' });
      return;
    }
    el.animate([{ opacity: 0, transform: 'translateY(8px)' }, { opacity: 1, transform: 'none' }], {
      duration: 380,
      delay,
      easing: EASE_OUT,
      fill: 'backwards',
    });
  }

  // Bubble pengguna berangkat dari tempat teksnya tadi berada (input atau chip), lalu mendarat di posisinya.
  function flyFrom(row, from, align) {
    const b = row.querySelector('.mchat__bubble');
    if (!canAnimate || !from || reduced()) return arrive(row);
    const r = b.getBoundingClientRect();
    const dx = align === 'left' ? from.left - r.left : from.right - r.right;
    const dy = from.top + from.height / 2 - (r.top + r.height / 2);
    b.animate(
      [
        { transform: `translate(${dx}px, ${dy}px) scale(0.92)`, opacity: 0.5 },
        { transform: 'none', opacity: 1 },
      ],
      { duration: 460, easing: EASE_OUT }
    );
  }

  // Jawaban "mengembang" dari ukuran bubble titik-titik.
  function unfold(row, from) {
    const b = row.querySelector('.mchat__bubble');
    if (!canAnimate || !from || reduced()) return arrive(row);
    const r = b.getBoundingClientRect();
    const right = Math.max(0, r.width - from.width);
    const bottom = Math.max(0, r.height - from.height);
    b.animate(
      [
        { clipPath: `inset(0px ${right}px ${bottom}px 0px round 4px 15px 15px 15px)` },
        { clipPath: 'inset(0px 0px 0px 0px round 4px 15px 15px 15px)' },
      ],
      { duration: 520, easing: EASE_OUT }
    );
  }

  // Elemen yang menghilang (chip lain) diganti "hantu" di posisi yang sama lalu memudar — tanpa lompatan layout.
  function ghostOut(els) {
    if (!canAnimate || reduced()) return;
    const host = panel.getBoundingClientRect();
    for (const el of els) {
      const r = el.getBoundingClientRect();
      const g = el.cloneNode(true);
      g.setAttribute('aria-hidden', 'true');
      g.tabIndex = -1;
      Object.assign(g.style, { position: 'absolute', left: `${r.left - host.left}px`, top: `${r.top - host.top}px`, width: `${r.width}px`, margin: '0', pointerEvents: 'none', zIndex: '2' });
      panel.appendChild(g);
      g.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'scale(0.96)' }], { duration: 180, easing: EASE_EXIT }).finished.then(() => g.remove());
    }
  }

  let panelAnim = null;
  function animatePanel(opening) {
    if (!canAnimate) return Promise.resolve();
    // Dibuka/ditutup lagi di tengah animasi → balik arah dari posisi sekarang, bukan lompat.
    if (panelAnim && panelAnim.playState === 'running') {
      if (panelAnim.opening !== opening) {
        panelAnim.reverse();
        panelAnim.opening = opening;
      }
      return panelAnim.finished.catch(() => {});
    }
    let frames;
    let timing;
    if (reduced()) {
      frames = [{ opacity: 0 }, { opacity: 1 }];
      timing = { duration: 200, easing: 'ease' };
    } else if (isSheet()) {
      frames = [{ transform: 'translateY(100%)' }, { transform: 'none' }];
      timing = { duration: 480, easing: EASE_SHEET };
    } else {
      const l = launcher.getBoundingClientRect();
      const p = panel.getBoundingClientRect();
      const inset = [l.top - p.top, p.right - l.right, p.bottom - l.bottom, l.left - p.left].map((v) => `${Math.max(0, v)}px`).join(' ');
      frames = [
        { clipPath: `inset(${inset} round ${l.height / 2}px)`, transform: 'scale(0.97)', opacity: 0.4, offset: 0 },
        { opacity: 1, offset: 0.35 },
        // Inset negatif di akhir: bayangan panel tidak ikut terpotong (sudut tetap dari border-radius panel).
        { clipPath: 'inset(-60px -60px -60px -60px round 15px)', transform: 'none', opacity: 1, offset: 1 },
      ];
      timing = { duration: 540, easing: EASE_SHEET };
    }
    if (!opening) {
      frames = frames.slice().reverse().map((f) => ({ ...f, offset: f.offset === undefined ? undefined : 1 - f.offset }));
      timing = { ...timing, duration: Math.round(timing.duration * 0.6), easing: reduced() ? 'ease' : EASE_EXIT };
    }
    panelAnim = panel.animate(frames, timing);
    panelAnim.opening = opening;
    return panelAnim.finished.catch(() => {});
  }

  function sendNudge() {
    if (!canAnimate || reduced()) return;
    send.querySelector('img').animate(
      [
        { transform: 'none', opacity: 1 },
        { transform: 'translateX(14px)', opacity: 0, offset: 0.4 },
        { transform: 'translateX(-14px)', opacity: 0, offset: 0.41 },
        { transform: 'none', opacity: 1 },
      ],
      { duration: 460, easing: EASE_OUT }
    );
  }

  // ---------- Render ----------

  function bubble(role, html, opts = {}) {
    const row = document.createElement('div');
    row.className = `mchat__msg mchat__msg--${role}${opts.error ? ' mchat__msg--error' : ''}`;
    const b = document.createElement('div');
    b.className = 'mchat__bubble';
    b.innerHTML = html;
    row.appendChild(b);
    log.appendChild(row);
    return row;
  }

  // Harga sudah diformat oleh Worker sesuai market pembeli (format sama dengan museo-money: CA$, $, AU$…).
  function cards(products, fresh) {
    if (!products || !products.length) return;
    const wrap = document.createElement('div');
    wrap.className = 'mchat__cards';
    for (const p of products) {
      const href = safeHref(p.url);
      if (!href) continue;
      const img = p.image ? `${p.image}${p.image.includes('?') ? '&' : '?'}width=160` : '';
      const a = document.createElement('a');
      a.className = 'mchat__card';
      a.href = href;
      a.innerHTML =
        (img ? `<img class="mchat__card-img" src="${escapeHtml(img)}" alt="" width="56" height="56">` : '<span class="mchat__card-img"></span>') +
        `<span class="mchat__card-body"><span class="mchat__card-title">${escapeHtml(p.title || '')}</span>` +
        `<span class="mchat__card-meta"><span class="mchat__card-price">${escapeHtml(String(p.price || ''))}</span>` +
        (p.compare_at ? `<s class="mchat__card-was">${escapeHtml(String(p.compare_at))}</s>` : '') +
        (p.available === false ? '<span class="mchat__card-oos">Sold out</span>' : '') +
        '</span></span>' +
        '<svg class="mchat__card-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';
      wrap.appendChild(a);
    }
    log.appendChild(wrap);
    // Masuk berurutan setelah bubble jawaban selesai mengembang (maks. 4 kartu → total jeda ≤ 400 ms).
    if (fresh) [...wrap.children].forEach((card, i) => arrive(card, 200 + i * 70));
  }

  function suggestionChips(animated) {
    if (!chipTemplate || !chipTemplate.content.querySelector('.mchat__chip')) return;
    const wrap = document.createElement('div');
    wrap.className = 'mchat__chips';
    wrap.appendChild(chipTemplate.content.cloneNode(true));
    log.appendChild(wrap);
    if (animated) [...wrap.querySelectorAll('.mchat__intro, .mchat__chip')].forEach((el, i) => arrive(el, 60 + i * 30));
  }

  function renderAll(animated) {
    log.innerHTML = '';
    if (!state.messages.length) suggestionChips(animated);
    for (const m of state.messages) {
      if (m.role === 'user') bubble('user', escapeHtml(m.content));
      else {
        bubble('bot', markdown(m.content));
        cards(m.products);
      }
    }
    if (state.messages.length) scrollDown();
    else log.scrollTop = 0;
  }

  function scrollDown() {
    log.scrollTop = log.scrollHeight;
  }

  // Jawaban panjang: gulir sampai awal jawaban terlihat, bukan langsung ke dasar (biar bisa dibaca dari atas).
  function reveal(row) {
    const target = Math.min(row.offsetTop - 16, log.scrollHeight - log.clientHeight);
    log.scrollTo({ top: Math.max(target, log.scrollTop), behavior: reduced() ? 'auto' : 'smooth' });
  }

  // Indikator menunggu: titik-titik, lalu teks status kalau jawabannya lama (cari produk / cek order bisa 5–10 dtk).
  function pending() {
    const row = document.createElement('div');
    row.className = 'mchat__msg mchat__msg--bot mchat__pending';
    row.innerHTML = '<span class="mchat__dots" aria-hidden="true"><span></span><span></span><span></span></span><span class="mchat__status" role="status"><span class="mchat__sr">Assistant is typing</span></span>';
    log.appendChild(row);
    arrive(row, 120);
    const dots = row.querySelector('.mchat__dots');
    const status = row.querySelector('.mchat__status');
    const steps = [
      [2500, 'Looking that up…'],
      [8000, 'Still checking the store — almost there…'],
    ];
    const timers = steps.map(([ms, text]) =>
      setTimeout(() => {
        status.textContent = text;
        status.classList.add('is-shown');
        if (canAnimate && !reduced()) status.animate([{ opacity: 0, transform: 'translateY(3px)' }, { opacity: 1, transform: 'none' }], { duration: 320, easing: EASE_OUT });
      }, ms)
    );
    return () => {
      const rect = dots.getBoundingClientRect();
      timers.forEach(clearTimeout);
      row.remove();
      return rect;
    };
  }

  function showError(text, retryText, from) {
    const row = bubble('bot', escapeHtml(text), { error: true });
    if (retryText) {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mchat__retry';
      btn.textContent = 'Try again';
      btn.addEventListener('click', () => {
        row.remove();
        input.value = '';
        ask(retryText);
      });
      row.querySelector('.mchat__bubble').appendChild(document.createElement('br'));
      row.querySelector('.mchat__bubble').appendChild(btn);
    }
    unfold(row, from);
    reveal(row);
  }

  // ---------- Open / close ----------

  function open(focus = true, animated = true) {
    const wasOpen = root.classList.contains('is-open');
    panel.hidden = false;
    root.classList.add('is-open');
    launcher.setAttribute('aria-expanded', 'true');
    state.open = true;
    save();
    if (state.messages.length) scrollDown();
    else log.scrollTop = 0; // layar awal (topik) dibaca dari atas
    if (animated && !wasOpen) animatePanel(true);
    if (focus) setTimeout(() => input.focus({ preventScroll: true }), 80);
    if (isSheet()) document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    if (!root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    launcher.setAttribute('aria-expanded', 'false');
    state.open = false;
    save();
    document.documentElement.style.overflow = '';
    launcher.focus({ preventScroll: true });
    animatePanel(false).then(() => {
      if (!root.classList.contains('is-open')) panel.hidden = true;
    });
  }

  // ---------- Kirim ----------

  // from: { rect, align } — asal teks pertanyaan (chip yang diklik, atau kolom input).
  async function ask(text, from) {
    text = text.trim();
    if (!text || busy) return;
    busy = true;
    const origin = from || { rect: input.getBoundingClientRect(), align: 'right' };
    const chipRow = log.querySelector('.mchat__chips');
    if (chipRow) {
      ghostOut([...chipRow.children].filter((c) => !from || c !== from.el));
      chipRow.remove();
    }
    state.messages.push({ role: 'user', content: text });
    save();
    const row = bubble('user', escapeHtml(text));
    input.value = '';
    autosize();
    scrollDown();
    flyFrom(row, origin.rect, origin.align);
    const done = pending();
    log.scrollTo({ top: log.scrollHeight, behavior: reduced() ? 'auto' : 'smooth' });

    try {
      const payload = {
        messages: state.messages.slice(-12).map((m) => ({ role: m.role, content: m.content })),
        context: {
          page: document.title,
          product: root.dataset.product || undefined,
          country: (window.Shopify && window.Shopify.country) || undefined,
        },
      };
      let res = await postChat(payload, false);
      if (res.status === 401) res = await postChat(payload, true); // sesi kedaluwarsa → verifikasi ulang
      const data = await res.json().catch(() => ({}));
      const dotsRect = done();
      if (!res.ok || !data.reply) {
        state.messages.pop(); // biar pertanyaan bisa dikirim ulang tanpa duplikat di riwayat
        if (res.status === 429) showError('You’re sending messages a little fast. Wait a few seconds, then try again.', text, dotsRect);
        else showError(root.dataset.error, text, dotsRect);
      } else {
        const msg = { role: 'assistant', content: data.reply, products: data.products || [] };
        state.messages.push(msg);
        const reply = bubble('bot', markdown(msg.content));
        cards(msg.products, true);
        unfold(reply, dotsRect);
        reveal(reply);
      }
    } catch (e) {
      const dotsRect = done();
      state.messages.pop();
      showError(navigator.onLine === false ? 'You seem to be offline. Check your connection and try again.' : root.dataset.error, text, dotsRect);
    }
    save();
    busy = false;
    autosize();
  }

  function autosize() {
    // Kosong → kembali ke tinggi CSS (scrollHeight ikut menghitung placeholder yang terbungkus di layar sempit).
    input.style.height = 'auto';
    input.style.height = input.value ? Math.min(input.scrollHeight, 120) + 'px' : '';
    send.disabled = busy || !input.value.trim();
  }

  // ---------- Events ----------

  launcher.addEventListener('click', () => {
    open();
    getSession(false).catch(() => {}); // siapkan sesi selagi pengunjung mengetik
  });
  root.querySelector('[data-mchat-close]').addEventListener('click', close);
  root.querySelector('[data-mchat-reset]').addEventListener('click', () => {
    if (busy) return;
    const restart = () => {
      state.messages = [];
      save();
      renderAll(true);
      input.value = '';
      autosize();
      input.focus();
    };
    // Percakapan lama memudar cepat dulu, lalu sapaan + saran masuk lagi — terasa seperti "halaman baru".
    if (!canAnimate || reduced() || !state.messages.length) return restart();
    log.animate([{ opacity: 1 }, { opacity: 0, transform: 'translateY(-6px)' }], { duration: 160, easing: EASE_EXIT }).finished.then(restart);
  });
  panel.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
  log.addEventListener('click', (e) => {
    const chip = e.target.closest('button.mchat__chip'); // tautan (mis. halaman kontak) tetap jadi tautan biasa
    if (chip) ask(chip.textContent, { el: chip, rect: chip.getBoundingClientRect(), align: 'left' });
    const link = e.target.closest('a[href*="/products/"]');
    if (link) trackClick(link.href);
  });

  // Klik produk dari jawaban bot → "produk paling sering diklik" di dashboard admin. sendBeacon tetap terkirim
  // walau halaman langsung berpindah; text/plain supaya tidak perlu preflight CORS.
  function trackClick(url) {
    try {
      const s = JSON.parse(sessionStorage.getItem(SESSION_KEY));
      if (!s || !s.token || !navigator.sendBeacon) return;
      navigator.sendBeacon(base + '/event', new Blob([JSON.stringify({ token: s.token, type: 'click', url })], { type: 'text/plain' }));
    } catch (e) {}
  }
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    if (!busy && input.value.trim()) sendNudge();
    ask(input.value);
  });
  input.addEventListener('input', autosize);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
      e.preventDefault();
      form.requestSubmit();
    }
  });

  renderAll();
  save();
  // Di mobile panel layar penuh, jadi tidak dibuka ulang otomatis saat pindah halaman.
  if (state.open && !isSheet()) open(false, false);

  // Launcher muncul sekali per sesi, sedikit setelah halaman tenang — tidak ikut berebut perhatian saat load.
  try {
    if (!state.open && !sessionStorage.getItem('museo-chat:seen') && canAnimate) {
      launcher.animate(
        reduced() ? [{ opacity: 0 }, { opacity: 1 }] : [{ opacity: 0, transform: 'translateY(16px) scale(0.92)' }, { opacity: 1, transform: 'none' }],
        { duration: 600, delay: 900, easing: EASE_OUT, fill: 'backwards' }
      );
    }
    sessionStorage.setItem('museo-chat:seen', '1');
  } catch (e) {}
})();
